// extracted by mini-css-extract-plugin
export default {"title":"Title_title__0-XrC","isCenteredTitle":"Title_isCenteredTitle__2EbR+"};